const defaultRoute = {
	exact: false,
	path: null,
	component: null,
	private: false,
	useLayout: true,
	title: null,
};


export default function createRoute(routeConfig = {}) {
	let fullRoute = {...defaultRoute, ...routeConfig};
	let {exact, path, render, ...extras} = fullRoute;

	return {route: {exact, path}, extras, render};
}